import { themeStyle } from '@repo/ui/theming';

import { TextAreaTheme } from './types';

export const defaultTheme: TextAreaTheme = {
  // size
  width: '100%',

  // textarea
  color: themeStyle.varInkMedium,
  colorActive: themeStyle.varInkMain,
  backgroundColor: themeStyle.varBackgroundAlt,
  border: '1px solid',
  borderColor: themeStyle.varInkLight,
  borderRadius: themeStyle.radiusMedium,

  // input text
  fontWeight: themeStyle.fontMedium,
  fontSize: themeStyle.fontSize14,
  lineHeight: '22px',
  textAlign: 'left',
};
